import { AfterViewInit, Component, HostListener, Input, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ConferenceRegistrantViewModel, ConferenceViewModelWithDetails, CourseEventViewModel, ModifyRegistrationViewModel, PackageAddonViewModel, RegistrantSearchParameters, RegistrationPackageViewModel, UserPackagePurchaseViewModel } from 'src/app/_models/generatedModels';
import { ConferenceCMSService, OrganizationService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import Keyboard from "simple-keyboard";
import { ActivatedRoute, Router } from "@angular/router";
import { IdleService } from "../../../_services/idle.service";
import { CheckinService } from "../../../_services/checkin.service";
import Enumerable from "linq";
import { log } from "@opentok/client";


declare var zE: any;

@Component({
  selector: 'bxl-checkin-preview-modal',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'modify-purchase-at-checkin.component.html',
})
export class ModifyPurchaseAtCheckinComponent implements OnInit {
  initialized: boolean;
  packageData: RegistrationPackageViewModel;
  submitComplete: Promise<{}> | undefined;

  model: ModifyRegistrationViewModel;
  addons: PackageAddonViewModel[];
  eventAddons: CourseEventViewModel[];
  existingRegistration: UserPackagePurchaseViewModel;
  actualPrice: number;
  @ViewChild('theForm', { static: false }) public userFrm: NgForm;
   errorMessage: string;
  public cardNumber: string;
  public expMo: string;
  public expYr: string;
  public cvv: string;


  constructor(private orgService: OrganizationService, public activeModal:NgbActiveModal, private zone: NgZone,private modalService: NgbModal, private conferenceCMSService: ConferenceCMSService, private idleService: IdleService, private router: Router, public checkinService: CheckinService, private route: ActivatedRoute,  private toaster: ToasterService) {
    idleService.idle$.subscribe(s => this.cancel());
    idleService.wake$.subscribe(s => console.log('im awake!'));
  }

  ngOnInit(): void {
    zE('webWidget', 'hide');
    console.log(this.checkinService.conference.id);

    this.conferenceCMSService.hasRegisteredForConference(this.checkinService.conference.id.toString(), this.checkinService.user.id).subscribe((existingRegistration) => {
      this.conferenceCMSService.getSingleRegistrationPackage(this.checkinService.conference.slug, this.checkinService.user.packageId).subscribe((result) => {
        this.packageData = result;
        this.existingRegistration = existingRegistration;
        this.model = new ModifyRegistrationViewModel();
        var addons = Enumerable.from(result.addOns);
        var purchasedAddons = Enumerable.from(existingRegistration.addOns).select((x) => x.addOnId);

        this.addons = addons.where((x) => !purchasedAddons.contains(x.id)).toArray();

        this.eventAddons = Enumerable.from(existingRegistration.package.eventAddons)
          .where((x) => !x.userHasPurchased && x.startTime > new Date())
          .toArray();

        if ( this.addons.length ==0 && this.eventAddons.length == 0 && (!this.packageData.ceUsAreExtra || this.existingRegistration.paidForCEUs)) {
          this.router.navigate(['../preview'], {relativeTo: this.route});
        }

        console.log(this.eventAddons);
        this.initialized = true;
      });
    });


  }

  cancel() {
    this.checkinService.reset();
    this.router.navigate(['../'], {relativeTo: this.route});
  }

  calculatePrice() {
    this.actualPrice = 0;

    if (this.model.purchaseCEUs && this.existingRegistration.memberRate && this.existingRegistration.package.memberPricing) {
      this.actualPrice += this.existingRegistration.package.ceuPrice;
    }

    if (this.model.purchaseCEUs && !this.existingRegistration.memberRate && this.existingRegistration.package.memberPricing) {
      this.actualPrice += this.existingRegistration.package.ceuNonMemberPrice;
    }

    if (this.model.purchaseCEUs && !this.existingRegistration.package.memberPricing) {
      this.actualPrice += this.existingRegistration.package.ceuPrice;
    }

    var addonPrice = Enumerable.from(this.addons)
      .where((x) => x.selected)
      .sum((x) => x.price);
    this.actualPrice += addonPrice;

    var eventAddonPrice = Enumerable.from(this.eventAddons)
      .where((x) => x.selected)
      .sum((x) => x.price);
    this.actualPrice += eventAddonPrice;
  }

  markAllTouched() {
    Object.keys(this.userFrm.controls).forEach((field) => {
      // {1}
      const control = this.userFrm.control.get(field);
      console.log(control); // {2}
      control.markAsTouched({onlySelf: true});
      control.markAsDirty({onlySelf: true}); // {3}
    });
  }

  purchasePackageClicked(modal) {
    if (!this.userFrm.valid) {
      this.markAllTouched();
      this.errorMessage = 'There are some invalid or missing fields. Please fill out all required fields.';
      return;
    }

    this.errorMessage = '';

    this.model.selectedAddOns = Enumerable.from(this.addons)
      .where((x) => x.selected)
      .toArray();

    this.model.selectedEventAddons = Enumerable.from(this.eventAddons)
      .where((x) => x.selected)
      .toArray();


    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.purchasePackage(resetButton, modal);
    });
  }

  purchasePackage(resetButton, modal) {
    if (this.actualPrice == 0) {
      this.purchasePackageFree(resetButton, modal);
      return;
    }

    let card = {
      number: this.cardNumber,
      exp_month: this.expMo,
      exp_year: this.expYr,
      cvc: this.cvv
    };
    (<any>window).Stripe.card.createToken(card, (status: number, response: any) => {
      if (status === 200) {
        this.model.cardToken = response.id;

        this.zone.run(() => {
          this.conferenceCMSService.updatePackage(this.existingRegistration.packageId, this.checkinService.user.id, this.model).subscribe(
            (result) => {
              if (!result) {
                resetButton();
                this.errorMessage = 'Unable to process transaction';
                return;
              }

              resetButton();
              modal.close();
              console.log('here');
              this.checkinService.reloadUser();
              this.toaster.messageDialog('Purchase Successful', 'Your purchase was successful. You can continue with check-in!').subscribe();
              this.router.navigate(['../preview'], {relativeTo: this.route});

            },
            (error) => {
              resetButton();
              this.errorMessage = error.error[0];
            }
          );
        });
      } else {
        resetButton();
        this.errorMessage = response.error.message;
      }
    });
  }

  purchasePackageFree(resetButton: any, modal) {
    this.conferenceCMSService.updatePackage(this.existingRegistration.packageId, this.checkinService.user.id, this.model).subscribe(
      (result) => {
        if (!result) {
          resetButton();
          this.errorMessage = 'Unable to process transaction';
          return;
        }

        resetButton();
       modal.close();
        console.log('here');
        this.checkinService.reloadUser();
        this.toaster.messageDialog('Purchase Successful', 'Your purchase was successful. You can continue with check-in!').subscribe();
        this.router.navigate(['../preview'], {relativeTo: this.route});

      },
      (error) => {
        resetButton();
        this.errorMessage = error.error[0];
      }
    );
  }

  public next(ccContent) {
    this.model.selectedAddOns = Enumerable.from(this.addons)
      .where((x) => x.selected)
      .toArray();

    this.model.selectedEventAddons = Enumerable.from(this.eventAddons)
      .where((x) => x.selected)
      .toArray();

    if (this.model.selectedAddOns.length > 0 || this.model.selectedEventAddons.length > 0 || this.model.purchaseCEUs) {
      this.modalService.open(ccContent, {size: 'lg', centered: true, backdrop: 'static', keyboard: false}).result.then((result) => {}, (reason) => {});

      return;
    }else{
      this.router.navigate(['../preview'], {relativeTo: this.route});

    }
  }
}
